import moment from 'moment/moment';
import Model from '../model';

/**
 * Customer Model
 * @property title
 * @property first_name
 * @property last_name
 * @property dob
 * @property email
 * @property tel_home
 * @property tel_mobile
 * @property property_name_number
 * @property street
 * @property town
 * @property county
 * @property post_code
 * @property car_registration
 * @property vehicle_stock_number
 * @property version
 * @property contactable_email
 * @property contactable_sms
 * @property contactable_mail
 * @property contactable_post
 * @property fields
 * @property __className
 */
export default class CustomerModel extends Model {
  /**
   * Customer Model Constructor
   * add a 'fields' property which holds form-field types and validation information
   * @param customer
   */
  constructor(customer) {
    super(customer);

    this.__className = 'CustomerModel';

    this.fields = {
      title: {
        type: 'select',
        options: ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr'],
        validation: 'required',
      },
      first_name: { type: 'text', validation: 'required|alpha_spaces' },
      last_name: { type: 'text', validation: 'required|alpha_spaces' },
      tel_home: { type: 'telephone', validation: 'required' },
      tel_mobile: { type: 'telephone', validation: 'required' },
      dob: {
        type: 'date',
        max: moment().subtract(15, 'years').format('YYYY-MM-DD'),
        label: 'D.o.b',
        validation: 'required',
        format(val) {
          return moment(val).format('DD/MM/YYYY');
        },
      },
      email: { type: 'text', validation: 'required|email' },
      property_name_number: {
        type: 'text',
        label: 'Property Name/Number',
        validation: 'required',
        value: null,
      },
      street: { type: 'text', validation: 'required' },
      town: { type: 'text', validation: 'required' },
      county: { type: 'text', validation: 'required' },
      post_code: {
        type: 'text',
        validation: 'required',
      },
    };
  }

  /**
   * Save updates via the Api Service.
   * Models should use named exports and an update{ModelName}(data) method needs to be
   * defined in /resources/assets/js/services/api.service.js
   * @returns {Promise<any>}
   * @throws Method is undefined
   */
  saveContactPreferences() {
    if (this.__className === null) {
      throw Error('The model __className property must be set.');
    }

    try {
      return Model.getApi().saveContactPreferences(this);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return undefined;
    }
  }
}
